// extracted by mini-css-extract-plugin
export var closeButton = "_jq-2";
export var closeButtonIcon = "_jq-3";
export var lightboxContent = "_jq-1";
export var lightboxOverlay = "_jq-0";